import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import {
  confirmSignup,
  signup,
  SignupOutcome,
  UserConstants,
} from "../actions/user";
import SignupPage from "../components/Signup";

type AppDispatch = ThunkDispatch<RootReducerState, unknown, AuthenticationAction>;

interface MapStateToProps {
  auth: AuthenticationState;
}

const mapStateToProps = (state: RootReducerState): MapStateToProps => {
  return {
    auth: state.authentication,
  };
};

interface MapDispatchToProps {
  signupAction: (email: string, password: string, turnstileToken?: string) => Promise<SignupOutcome>;
  confirmSignupAction: (email: string, code: string, password: string) => Promise<SignupOutcome>;
  clearError: () => void;
}

const mapDispatchToProps = (dispatch: AppDispatch): MapDispatchToProps => ({
  signupAction: (email, password, turnstileToken) =>
    dispatch(signup(email, password, turnstileToken)),
  confirmSignupAction: (email, code, password) => dispatch(confirmSignup(email, code, password)),
  clearError: () => dispatch({ type: UserConstants.CLEAR_AUTH_ERROR }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupPage);
